import React, { Component } from 'react';
import { Table, Tooltip, Icon, message } from 'antd';
import { TeamFilter as Filter } from './SearchFilter';
import { TeamView as View } from './EfficiencyView';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class Team extends Component {
    state = {
        sortParams: {},
        searchParams: {},
        data: [],
        loading: false,
    }

    loadData = () => {
        const { sortParams, searchParams } = this.state;
        const { userId } = sessionStorage;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryPortalTeamEfficiency,
            data: {
                ...sortParams,
                ...searchParams,
                crcUserId: userId,
                relatedUser: 0,
            },
            dataType: 'json',
            doneResult: res => {
                const { efficiencyBeanList } = res;
                this.setState({
                    loading: false,
                    data: efficiencyBeanList || [],
                });
            }
        }
        $.sendRequest(options);
    }

    search = (params) => {
        this.setState({
            searchParams: params,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams } = this.state;
        const params = {
            ...sortParams,
            ...searchParams,
        }
        this.addToDownloadSite(params, API_URL.user.exportPortalTeamEfficiency, 'Team_Efficiency');
    }

    addToDownloadSite = (searchArray, url, type) => {
        const options = {
            method: 'POST',
            url: API_URL.common.startAsynchronousExport,
            data: { type },
            dataType: 'json',
            doneResult: (res) => {
                const { success, asynchronousExportId } = res;
                message.success(success);
                const params = { ...searchArray, asynchronousExportId }
                ExportUtil.export(params, null, url);
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        return (
            [{
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
            }, {
                title: '时间',
                dataIndex: 'time',
                key: 'time',
                width: 90,
            }, {
                title: '团队领导',
                dataIndex: 'leaderName',
                key: 'leaderName',
                width: 90,
            }, {
                title: '团队项目计划FTE',
                dataIndex: 'planFte',
                key: 'planFte',
                width: 125,
            }, {
                title: '团队项目消耗FTE',
                dataIndex: 'consumeFte',
                key: 'consumeFte',
                width: 125,
            }, {
                title: '团队完成访视数',
                dataIndex: 'visitCount',
                key: 'visitCount',
                width: 120,
            }, {
                title: '团队CRC项目确认FTE',
                dataIndex: 'monthCrcFte',
                key: 'monthCrcFte',
                width: 90,
            }, {
                title: '团队确认标准访视数',
                dataIndex: 'standardVisitCount',
                key: 'standardVisitCount',
                width: 90,
            }, {
                title: '团队访视效率比',
                dataIndex: 'visitRate',
                key: 'visitRate',
                width: 120,
            }, {
                title: '团队方案违背数',
                dataIndex: 'violationCount',
                key: 'violationCount',
                width: 120,
            }, {
                title: (
                    <span>
                        团队月空余率
                        <Tooltip overlayStyle={{ width: 200 }} placement="top" title={'团队空余率 = 该团队人员的“空余FTE”之和 / 团队人数'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'spareRate',
                key: 'spareRate',
                width: 120,
            }, {
                title: '操作',
                dataIndex: 'option',
                key: 'option',
                width: 90,
                render: (text, record) => {
                    const { investigationCode } = record;
                    return (
                        <div>
                            {
                                investigationCode !== '总计' &&
                                <a onClick={() => this.showView(record)}>查看明细</a>
                            }
                        </div>
                    )
                }
            }]
        )
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map((item, index) => {
            if (item.investigationCode != '总计') {
                return {
                    index: index + 1,
                    ...item,
                    planFte: item.planFte.toFixed(2),
                    spareRate: item.spareRate.toFixed(2),
                    consumeFte: item.consumeFte.toFixed(2),
                };
            } else if (item.investigationCode == '总计') {
                return {
                    index: item.investigationCode,
                    ...item,
                    planFte: item.planFte.toFixed(2),
                    spareRate: item.spareRate.toFixed(2),
                    consumeFte: item.consumeFte.toFixed(2),
                };
            }
        });
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field == 'time' ? 'date' : sorter.field;
        sortParams.direction = sorter.order ? sorter.order === 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    showView = record => {
        this.viewRef.show(record);
    }

    render() {
        const { loading } = this.state;
        return (
            <div>
                <Filter search={this.search} export={this.export} />
                <Table
                    columns={this.getColumns()}
                    dataSource={this.getDataSource()}
                    rowKey={record => record.index}
                    loading={loading}
                    scroll={{ x: 1240 }}
                    onChange={this.handleTableChange}
                    pagination={false}
                />
                <View ref={el => this.viewRef = el} />
            </div>
        );
    }
}

export default Team;


// WEBPACK FOOTER //
// ./src/components/user/userEfficiency/Team.js